import React, { useEffect } from 'react';

const RedirectToExternalBrowser = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (userAgent.includes("Telegram")) {
      const chromeIntent = `intent://${window.location.host}${window.location.pathname}#Intent;scheme=https;package=com.android.chrome;end`;
      window.location.href = chromeIntent;
    }
  }, []);

  return null; // This component doesn't need to render anything
};

export default RedirectToExternalBrowser;
